import React, { useState, useEffect } from "react";
import { MdOutlineMailOutline, MdPersonOutline } from "react-icons/md";
import axios from "axios";
import { FaCoins, FaWallet, FaCommentDots } from "react-icons/fa";
import { db } from "../lib/firebase";
import { collection, query, where, getDocs, orderBy, limit as fsLimit, doc, getDoc } from "firebase/firestore";

export default function UserDetailsModal({ model, onClose, userId }) {
  const [activeTab, setActiveTab] = useState("Profile");
  const [coinStats, setCoinStats] = useState({
    availableCoins: 0,
    purchasedCoins: 0,
    spentCoins: 0,
    sendGiftCoins: 0,
    loading: true
  });
  const [withdrawalStats, setWithdrawalStats] = useState({
    availableCoins: 0,
    earnedCoins: 0,
    earnedGiftsCoins: 0,
    drawnCoins: 0,
    drawnAmount: 0,
    loading: true
  });


  const [conversionSummary, setConversionSummary] = useState({
  totalCoinsConverted: 0,
  totalRupeesEarned: 0,
  availableBalance: 0,
  withdrawnAmount: 0,
  loading: true
});

  const [coinsToRupees, setCoinsToRupees] = useState(10);
  const [userData, setUserData] = useState(null);
  const [callTx, setCallTx] = useState({ list: [], loading: false, page: 1, totalPages: 1 });
  const [coinTx, setCoinTx] = useState({ list: [], loading: false, page: 1, totalPages: 1 });
  const [purchaseTx, setPurchaseTx] = useState({ list: [], loading: false, page: 1, totalPages: 1 });
  const [withdrawTx, setWithdrawTx] = useState({ list: [], loading: false, page: 1, totalPages: 1 });
  const [chats, setChats] = useState({ list: [], loading: false });
  const [selectedChat, setSelectedChat] = useState(null);
  const [chatMessages, setChatMessages] = useState({ list: [], loading: false });
  const [isDeletingUser, setIsDeletingUser] = useState(false);
  const messagesEndRef = React.useRef(null);

  useEffect(() => {
    if (userId && activeTab === "Chats") {
      fetchUserChats();
    }
  }, [userId, activeTab]);

  const [profileBgData, setProfileBgData] = useState({
  user: null,
  backgrounds: [],
  loading: false
});


const fetchConversionSummary = async () => {
  try {
    setConversionSummary(prev => ({ ...prev, loading: true }));

    const res = await axios.get(
      `/api/v1/app/conversion/summary/${userId}`
    );

    if (res.data.status === "OK") {
      const s = res.data.data.summary;

      setConversionSummary({
        totalCoinsConverted: s.totalCoinsConverted || 0,
        totalRupeesEarned: s.totalRupeesEarned || 0,
        availableBalance: s.availableBalance || 0,
        withdrawnAmount: s.withdrawnAmount || 0,
        loading: false
      });
    }

  } catch (err) {
    console.error("Conversion Summary Error:", err);
    setConversionSummary(prev => ({ ...prev, loading: false }));
  }
};

const fetchProfileBackgrounds = async () => {
  try {
    setProfileBgData(prev => ({ ...prev, loading: true }));

    const res = await axios.get(
      `/api/v2/userPaidProfileBackground/admin/user-profile-backgrounds/${userId}`
    );

    if (res.data.success) {
      setProfileBgData({
        user: res.data.data.user,
        backgrounds: res.data.data.backgrounds,
        loading: false
      });
    }

  } catch (err) {
    console.error("Error fetching profile backgrounds", err);
    setProfileBgData(prev => ({ ...prev, loading: false }));
  }
};


useEffect(() => {
  if (userId && activeTab === "Profile") {
    fetchProfileBackgrounds();
  }
}, [userId, activeTab]);

  useEffect(() => {
    if (userId && activeTab === "Activity") {
      fetchCoinStats();
      if (model?.gender?.toLowerCase() === "female") {
        fetchWithdrawalStats();
          fetchConversionSummary();   // ✅ NEW
        fetchConversionSettings();
      }
    }
  }, [userId, activeTab, model?.gender]);

  useEffect(() => {
    if (userId && activeTab === "Call Transactions") {
      fetchCallTransactions(1);
    }
  }, [userId, activeTab]);

  useEffect(() => {
    if (userId && activeTab === "Earning/Deductions") {
      fetchCoinTransactions(1);
    }
  }, [userId, activeTab]);

  useEffect(() => {
    if (!userId) return;
    if (activeTab === "Purchases/Withdraws") {
      const isFemale = model?.gender?.toLowerCase() === "female";
      if (isFemale) {
        fetchUserWithdrawals(1);
        fetchConversionSettings();
      } else {
        fetchPurchaseHistory(1);
      }
    }
  }, [userId, activeTab, model?.gender]);

  const fetchCallTransactions = async (page = 1) => {
    try {
      setCallTx((p) => ({ ...p, loading: true }));
      const res = await axios.get(`/api/v1/app/call-transactions/getCallHistory/${userId}`, {
        params: { page, limit: 10 }
      });
      if (res.data.status === "OK" && res.data.data) {
        setCallTx({
          list: res.data.data.transactions || [],
          loading: false,
          page: res.data.data.currentPage || page,
          totalPages: res.data.data.totalPages || 1
        });
      } else {
        setCallTx({ list: [], loading: false, page: 1, totalPages: 1 });
      }
    } catch (e) {
      setCallTx({ list: [], loading: false, page: 1, totalPages: 1 });
    }
  };

  const fetchConversionSettings = async () => {
    try {
      const response = await axios.get("/api/v1/app/conversion/settings");
      if (response.data.status === "OK") {
        const s = response.data.data.settings;
        const rate = Number(s?.coinToRupeesRate);
        if (rate && rate > 0) setCoinsToRupees(rate);
      }
    } catch (e) {}
  };

  const fetchCoinTransactions = async (page = 1) => {
    try {
      setCoinTx((p) => ({ ...p, loading: true }));
      const res = await axios.get(`/api/v1/app/coin-earnings/get-transactions/${userId}`, {
        params: { page, limit: 10 }
      });
      if (res.data.status === "OK" && res.data.data) {
        setCoinTx({
          list: res.data.data.transactions || [],
          loading: false,
          page,
          totalPages: res.data.data.pagination?.totalPages || 1
        });
      } else {
        setCoinTx({ list: [], loading: false, page: 1, totalPages: 1 });
      }
    } catch (e) {
      setCoinTx({ list: [], loading: false, page: 1, totalPages: 1 });
    }
  };

  const fetchPurchaseHistory = async (page = 1) => {
    try {
      setPurchaseTx((p) => ({ ...p, loading: true }));
      const limit = 10;
      const res = await axios.get(`/api/v1/app/payments/gethistory/${userId}`, {
        params: { page, limit }
      });
      if (res.data.status === "OK" && res.data.data) {
        setPurchaseTx({
          list: res.data.data.transactions || [],
          loading: false,
          page: res.data.data.pagination?.currentPage || page,
          totalPages: res.data.data.pagination?.totalPages || 1
        });
      } else {
        setPurchaseTx({ list: [], loading: false, page: 1, totalPages: 1 });
      }
    } catch (e) {
      setPurchaseTx({ list: [], loading: false, page: 1, totalPages: 1 });
    }
  };

  const fetchUserWithdrawals = async (page = 1) => {
    try {
      setWithdrawTx((p) => ({ ...p, loading: true }));
      const res = await axios.get(`/api/v1/app/wallet/withdrawal-requests?page=${page}`);
      if (res.data.status === "OK" && res.data.data) {
        const all = res.data.data.withdrawalRequests || [];
        const filtered = all.filter((w) => String(w.user?._id || "") === String(userId));
        setWithdrawTx({
          list: filtered,
          loading: false,
          page: res.data.data?.currentPage || page,
          totalPages: res.data.data?.totalPages || 1
        });
      } else {
        setWithdrawTx({ list: [], loading: false, page: 1, totalPages: 1 });
      }
    } catch (e) {
      setWithdrawTx({ list: [], loading: false, page: 1, totalPages: 1 });
    }
  };

  const fetchUserChats = async () => {
    if (!db || !userId) return;
    try {
      setChats({ list: [], loading: true });
      
      // 1. First, find the correct ID to use for participants query
      // The provided userId might be MongoDB _id, but participants might use Firestore doc ID or a custom userId field
      let searchIds = [String(userId)];
      if (!isNaN(userId)) searchIds.push(Number(userId));
      
      try {
        const userRef = collection(db, "users");
        const docRef = doc(db, "users", String(userId));
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const uData = docSnap.data();
          if (uData.userId && !searchIds.includes(String(uData.userId))) {
            searchIds.push(String(uData.userId));
            if (!isNaN(uData.userId)) searchIds.push(Number(uData.userId));
          }
        } else {
          // Try finding by userId field to get the document ID
          const q1 = query(userRef, where("userId", "==", String(userId)), fsLimit(1));
          const q2 = !isNaN(userId) ? query(userRef, where("userId", "==", Number(userId)), fsLimit(1)) : null;
          
          const [s1, s2] = await Promise.all([
            getDocs(q1),
            q2 ? getDocs(q2) : Promise.resolve({ empty: true })
          ]);
          
          const foundDoc = !s1.empty ? s1.docs[0] : (!s2.empty ? s2.docs[0] : null);
          if (foundDoc) {
            if (!searchIds.includes(foundDoc.id)) searchIds.push(foundDoc.id);
            const d = foundDoc.data();
            if (d.userId && !searchIds.includes(String(d.userId))) {
              searchIds.push(String(d.userId));
              if (!isNaN(d.userId)) searchIds.push(Number(d.userId));
            }
          }
        }
      } catch (e) {
        console.error("Error resolving user IDs for chat query:", e);
      }

      const chatsRef = collection(db, "chats");
      const allChatDocs = [];
      
      // 2. Query chats for all possible ID variations
      const queries = searchIds.map(id => 
        query(chatsRef, where("participants", "array-contains", id))
      );
      
      const snaps = await Promise.all(queries.map(q => getDocs(q)));
      snaps.forEach(snap => {
        snap.docs.forEach(doc => {
          if (!allChatDocs.find(d => d.id === doc.id)) {
            allChatDocs.push(doc);
          }
        });
      });

      // 3. Build chat list
      const chatList = [];
      const getTimestamp = (data) => {
        const ts = data.updatedAt || data.lastMessage?.timestamp || data.createdAt;
        if (!ts) return 0;
        if (ts.toDate) return ts.toDate().getTime();
        if (ts instanceof Date) return ts.getTime();
        const parsed = new Date(ts).getTime();
        return isNaN(parsed) ? 0 : parsed;
      };

      for (const d of allChatDocs) {
        const data = d.data();
        const otherId = data.participants.find(p => !searchIds.includes(String(p)) && !searchIds.includes(Number(p)));
        
        let otherUser = { name: "Unknown", image: "" };
        if (otherId) {
          try {
            // 1. Try by Document ID first
            const otherDocRef = doc(db, "users", String(otherId));
            const otherDocSnap = await getDoc(otherDocRef);
            
            if (otherDocSnap.exists()) {
              const uData = otherDocSnap.data();
              otherUser = {
                name: uData.fullName || uData.name || uData.displayName || "Unknown",
                image: uData.image || uData.profileImage || uData.photoURL || ""
              };
            } else {
              // 2. Fallback to userId field
              const userRef = collection(db, "users");
              const userQString = query(userRef, where("userId", "==", String(otherId)), fsLimit(1));
              const userQNumber = !isNaN(otherId) ? query(userRef, where("userId", "==", Number(otherId)), fsLimit(1)) : null;

              const [uSnapString, uSnapNumber] = await Promise.all([
                getDocs(userQString),
                userQNumber ? getDocs(userQNumber) : Promise.resolve({ empty: true })
              ]);

              const uSnap = !uSnapString.empty ? uSnapString : (!uSnapNumber.empty ? uSnapNumber : { empty: true });

              if (!uSnap.empty) {
                const uData = uSnap.docs[0].data();
                otherUser = {
                  name: uData.fullName || uData.name || uData.displayName || "Unknown",
                  image: uData.image || uData.profileImage || uData.photoURL || ""
                };
              }
            }
          } catch (e) {
            console.error("Error fetching other user details for chat:", e);
          }
        }
        
        chatList.push({
          id: d.id,
          ...data,
          otherUser,
          sortTimestamp: getTimestamp(data)
        });
      }
      
      const sortedList = [...chatList].sort((a, b) => b.sortTimestamp - a.sortTimestamp);
      setChats({ list: sortedList, loading: false });
    } catch (e) {
      console.error("Error fetching user chats:", e);
      setChats({ list: [], loading: false });
    }
  };

  const fetchChatMessages = async (chatId) => {
    if (!db || !chatId) return;
    try {
      setChatMessages({ list: [], loading: true });
      const chatRef = doc(db, "chats", chatId);
      const messagesRef = collection(chatRef, "messages");
      const q = query(messagesRef, orderBy("timestamp", "asc"));
      const snap = await getDocs(q);
      const msgs = snap.docs.map(d => ({
        id: d.id,
        ...d.data(),
        timestamp: d.data().timestamp?.toDate?.() || new Date(d.data().timestamp || 0)
      }));
      setChatMessages({ list: msgs, loading: false });
    } catch (e) {
      console.error("Error fetching chat messages:", e);
      setChatMessages({ list: [], loading: false });
    }
  };

  // No longer correlating with coin transactions by time; use fields on call tx itself


  const fetchCoinStats = async () => {
    try {
      setCoinStats((prev) => ({ ...prev, loading: true }));
      const res = await axios.get(
        `/api/v1/app/coin-earnings/history/stats/${userId}`
      );
      const data = res.data || {};
      setCoinStats({
        availableCoins: data.availableCoins || 0,
        purchasedCoins: data.purchasedCoins || 0,
        spentCoins: data.spentCoins || 0,
        sendGiftCoins: data.sendGiftCoins || 0,
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching coin history stats:", error);
      setCoinStats((prev) => ({ ...prev, loading: false }));
    }
  };


  const fetchWithdrawalStats = async () => {
  try {
    setWithdrawalStats(prev => ({ ...prev, loading: true }));

    const res = await axios.get(
      `/api/v1/app/coin-earnings/withdrawal/stats/${userId}`
    );

    const d = res.data || {};

    setWithdrawalStats({
      availableCoins: d.availableCoins || 0,
      earnedCoins: d.earnedCoins || 0,
      earnedGiftsCoins: d.earnedGiftsCoins || 0,
      drawnCoins: d.drawnCoins || 0,
      drawnAmount: d.drawnAmount || 0,
      loading: false
    });

  } catch (e) {
    console.error("Withdraw Stats Error:", e);
    setWithdrawalStats(prev => ({ ...prev, loading: false }));
  }
};


  if (!model) return null;

  const displayValue = (value, fallback = "-") =>
    value && value !== "-" ? value : fallback;

  const adminUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("adminUser") || "{}");
    } catch {
      return {};
    }
  })();
  const canDelete = adminUser?.email === "admin@arrowcoders.com";
  const canSeeChats = adminUser?.email === "admin@arrowcoders.com";
  const isUserDeleted = Boolean(model?.isDeleted);

  const handleDeleteUser = async () => {
    if (!userId || isUserDeleted || isDeletingUser) return;
    const ok = window.confirm("Are you sure you want to permanently delete this user?");
    if (!ok) return;
    try {
      setIsDeletingUser(true);
      await axios.delete(`/api/v1/admin/users/${userId}`);
      alert("User deleted successfully");
      onClose && onClose();
      // Refresh parent list
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    } catch (e) {
      console.error("Delete user failed:", e);
      alert(e?.response?.data?.message || "Failed to delete user");
    } finally {
      setIsDeletingUser(false);
    }
  };

  const formatNumber = (n) => (n || 0).toLocaleString("en-IN");
  const formatCurrency = (amount) => `₹${(amount || 0).toLocaleString("en-IN")}`;
  const availableAmountRupees = coinsToRupees > 0 ? withdrawalStats.availableCoins / coinsToRupees : 0;

  return (
    <div className="fixed inset-0 bg-[var(--black)] bg-opacity-70 flex justify-center items-center z-50 p-4">
      <div className="bg-[var(--black)] text-[var(--yellow)] rounded-2xl w-full max-w-4xl shadow-xl overflow-hidden max-h-[90vh] flex flex-col border-2 border-[var(--yellow)]">

        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-[var(--yellow)] sticky top-0 bg-[var(--black)]">
          <h2 className="text-xl font-semibold">
            User Details - {displayValue(model.name)}
          </h2>

          <button
            onClick={onClose}
            className="text-[var(--yellow)] hover:opacity-80 text-3xl leading-none font-bold"
          >
            &times;
          </button>
        </div>

        {/* Scrollable content */}
        <div className="overflow-y-auto p-4 md:p-6">

          {/* Top section */}
          <div className="flex flex-col md:flex-row items-center gap-4 p-6 bg-[var(--black)] rounded-xl border border-[var(--yellow)]">
            <img
              src={displayValue(model.image, "https://via.placeholder.com/150")}
              alt="Profile"
              className="w-24 h-24 rounded-full object-cover border-2 border-[var(--yellow)]"
            />

            <div className="text-center md:text-left flex-1">
              <h3 className="text-2xl font-semibold">{displayValue(model.name)}</h3>
              <p className="opacity-90">{displayValue(model.email)}</p>

              {/* Tags */}
              <div className="mt-2 flex justify-center md:justify-start gap-2 flex-wrap">
                <span className={`text-sm px-3 py-1 rounded-full border ${isUserDeleted
                  ? "bg-red-600 text-white border-red-500"
                  : "bg-[var(--yellow)] text-[var(--black)] border-[var(--black)]"
                  }`}>
                  {isUserDeleted ? "Deleted" : "Active"}
                </span>
                <span className="text-sm bg-[var(--yellow)] text-[var(--black)] px-3 py-1 rounded-full border border-[var(--black)]">
                  {displayValue(model.gender)}
                </span>
              </div>
            </div>
            {canDelete && !isUserDeleted && (
              <div className="ml-auto">
                <button
                  onClick={handleDeleteUser}
                  disabled={isDeletingUser}
                  className="px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60 text-white font-semibold border border-red-500"
                  title="Delete User"
                >
                  {isDeletingUser ? "Deleting..." : "Delete User"}
                </button>
              </div>
            )}
          </div>

          {/* Tabs */}
          <div className="flex justify-center border-b border-[var(--yellow)] mt-6">
            <button
              className={`px-6 py-2 font-medium ${
                activeTab === "Profile"
                  ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
                  : "text-[var(--yellow)] opacity-60 hover:opacity-100"
              }`}
              onClick={() => setActiveTab("Profile")}
            >
              Profile
            </button>

            <button
              className={`px-6 py-2 font-medium ${
                activeTab === "Activity"
                  ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
                  : "text-[var(--yellow)] opacity-60 hover:opacity-100"
              }`}
              onClick={() => setActiveTab("Activity")}
            >
              Activity
            </button>

            {/* {canSeeChats && (
              <button
                className={`px-6 py-2 font-medium ${
                  activeTab === "Chats"
                    ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
                    : "text-[var(--yellow)] opacity-60 hover:opacity-100"
                }`}
                onClick={() => setActiveTab("Chats")}
              >
                Chats
              </button>
            )} */}

            <button
              className={`px-6 py-2 font-medium ${
                activeTab === "Call Transactions"
                  ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
                  : "text-[var(--yellow)] opacity-60 hover:opacity-100"
              }`}
              onClick={() => setActiveTab("Call Transactions")}
            >
              Call Transactions
            </button>

            <button
              className={`px-6 py-2 font-medium ${
                activeTab === "Earning/Deductions"
                  ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
                  : "text-[var(--yellow)] opacity-60 hover:opacity-100"
              }`}
              onClick={() => setActiveTab("Earning/Deductions")}
            >
              {model?.gender?.toLowerCase() === "female" ? "Earning" : "Deduction"}
            </button>

            <button
              className={`px-6 py-2 font-medium ${
                activeTab === "Purchases/Withdraws"
                  ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
                  : "text-[var(--yellow)] opacity-60 hover:opacity-100"
              }`}
              onClick={() => setActiveTab("Purchases/Withdraws")}
            >
              {model?.gender?.toLowerCase() === "female" ? "Withdraws" : "Purchages"}
            </button>
          </div>

          {/* TAB CONTENTS */}
          {activeTab === "Profile" ? (
            <>
              {/* Profile Info */}
              <div className="p-6 grid md:grid-cols-2 gap-6">

                {/* Contact Information */}
                <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                  <div className="flex items-center space-x-2 mb-4">
                    <MdOutlineMailOutline className="text-xl text-[var(--yellow)]" />
                    <h4 className="text-lg font-semibold">Contact Information</h4>
                  </div>

                  <ul className="space-y-2 text-sm">
                    <li>
                      <strong>Phone:</strong> {displayValue(model.phone)}
                    </li>
                    <li>
                      <strong>Address:</strong> {displayValue(model.address)}
                    </li>
                     <li>
                      <strong>Coordinates:</strong> {displayValue(model.latitude)} , {displayValue(model.longitude)}
                    </li>
                  </ul>
                </div>

                {/* Personal Details of user */}
                <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                  <div className="flex items-center space-x-2 mb-4">
                    <MdPersonOutline className="text-xl text-[var(--yellow)]" />
                    <h4 className="text-lg font-semibold">Personal Details</h4>
                  </div>

                  <ul className="space-y-2 text-sm">
                    <li><strong>Age:</strong> {displayValue(model.age)}</li>
                    <li><strong>Date of Birth:</strong> {displayValue(model.dob)}</li>
                    <li><strong>Gender:</strong> {displayValue(model.gender)}</li>
                      <li><strong>Occupation:</strong> {displayValue(model.occupation)}</li>
                    <li>
                      <strong>Role:</strong>{" "}
                      <span className="text-sm bg-[var(--yellow)] text-[var(--black)] px-2 py-1 rounded-md border border-[var(--black)]">
                        {displayValue(model.role)}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* About Me */}
<div className="p-6">
  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
    <h4 className="text-lg font-semibold mb-3">About Me</h4>

    {model.aboutMe ? (
      <p className="text-sm">{model.aboutMe}</p>
    ) : (
      <p className="text-sm opacity-70">No bio added</p>
    )}
  </div>
</div>


          {/* Social Stats moved from Activity to Profile */}
          <div className="p-6">
            <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
              <h4 className="text-lg font-semibold mb-4">Social Stats</h4>

              <div className="grid grid-cols-3 gap-4 text-center">
                {[
                  ["Followers", model.followers],
                  ["Following", model.following],
                  ["Friends", model.friends],
                ].map(([label, value]) => (
                  <div
                    key={label}
                    className="p-3 rounded-lg bg-[var(--black)] border border-[var(--yellow)]"
                  >
                    <p className="text-2xl font-bold">{value}</p>
                    <p className="text-sm opacity-80">{label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

              {/* Interests */}
<div className="p-6">
  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
  <h4 className="text-lg font-semibold mb-3">Interests</h4>


  {model.interests && model.interests.length > 0 ? (
    <div className="flex flex-wrap gap-2">
      {model.interests.map((interest, index) => (
        <span
          key={index}
          className="px-3 py-1 rounded-full text-sm bg-[var(--yellow)] text-[var(--black)]"
        >
          {interest}
        </span>
      ))}
    </div>
  ) : (
    <p className="text-sm opacity-70">No interests added</p>
  )}
</div>
</div>

              {/* Profile Image */}
              <div className="p-6">
                <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                  <h4 className="text-lg font-semibold mb-3">Profile Image</h4>

                  <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                    <img
                      src={displayValue(model.image)}
                      alt="Profile"
                      className="w-20 h-20 rounded-full object-cover border border-[var(--yellow)]"
                    />
                    <div className="break-all text-sm">
                      <strong>Image URL:</strong> {displayValue(model.image)}
                    </div>
                  </div>
                </div>
              </div>



{/* Photos */}
<div className="p-6">
  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
    <h4 className="text-lg font-semibold mb-3">Photos</h4>

    {model.photos && model.photos.length > 0 ? (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {model.photos.map((photo, index) => (
          <img
            key={index}
            src={photo}
            alt="User Photo"
            className="w-full h-28 object-cover rounded-lg border border-[var(--yellow)]"
          />
        ))}
      </div>
    ) : (
      <p className="text-sm opacity-70">No photos uploaded</p>
    )}
  </div>
</div>

{/* Profile Background */}
<div className="p-6">
  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
    <h4 className="text-lg font-semibold mb-3">Profile Background</h4>

    {profileBgData.loading ? (
      <p>Loading...</p>
    ) : profileBgData.user?.profileBackground?.url ? (
      <img
        src={profileBgData.user.profileBackground.url}
        alt="Profile Background"
        className="w-full h-40 object-cover rounded-lg border border-[var(--yellow)]"
      />
    ) : (
      <p className="text-sm opacity-70">No background selected</p>
    )}
  </div>
</div>


{/* Profile Background Gallery */}
<div className="p-6">
  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
    <h4 className="text-lg font-semibold mb-3">Uploaded Backgrounds</h4>

    {profileBgData.backgrounds.length > 0 ? (
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {profileBgData.backgrounds.map((bg) => (
          <div key={bg._id} className="relative">
            <img
              src={bg.image.url}
              alt="bg"
              className={`w-full h-24 object-cover rounded-lg border ${
                bg.isSelected
                  ? "border-green-500"
                  : "border-[var(--yellow)]"
              }`}
            />

            {bg.isSelected && (
              <span className="absolute top-1 right-1 bg-green-500 text-white text-xs px-2 py-1 rounded">
                Selected
              </span>
            )}
          </div>
        ))}
      </div>
    ) : (
      <p className="text-sm opacity-70">No backgrounds uploaded</p>
    )}
  </div>
</div>

            </>
          ) : activeTab === "Activity" ? (
            <>
              {/* ACTIVITY TAB */}
              <div className="p-6 space-y-6">

                {/* Activity Info */}
                <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                  <h4 className="text-lg font-semibold mb-4">Activity Information</h4>

                  <div className="grid md:grid-cols-2 gap-4 text-sm">
                    <div>
                      <p><strong>Online:</strong> {model.isOnline ? "Yes" : "No"}</p>
                      <p><strong>Last Active:</strong> {displayValue(model.lastActive)}</p>
                    </div>

                    <div>
                      <p><strong>Account Created:</strong> {displayValue(model.accountCreated)}</p>
                    </div>
                  </div>
                </div>

                {/* Coin History Stats - Not shown for female users */}
                {model?.gender?.toLowerCase() !== "female" && (
                  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                    <div className="flex items-center space-x-2 mb-4">
                      <FaCoins className="text-xl text-[var(--yellow)]" />
                      <h4 className="text-lg font-semibold">Coin History Stats</h4>
                    </div>

                    {coinStats.loading ? (
                      <div className="flex justify-center py-4">
                        <div className="w-6 h-6 border-2 border-[var(--yellow)] border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                        {[
                          ["Available Coins", coinStats.availableCoins],
                          ["Purchased Coins", coinStats.purchasedCoins],
                          ["Spent Coins", coinStats.spentCoins],
                          ["Send Gift Coins", coinStats.sendGiftCoins],
                        ].map(([label, value]) => (
                          <div
                            key={label}
                            className="p-3 rounded-lg bg-[var(--black)] border border-[var(--yellow)]"
                          >
                            <p className="text-2xl font-bold">{formatNumber(value)}</p>
                            <p className="text-sm opacity-80">{label}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Coins Withdraw History - Only for female users */}
                {model?.gender?.toLowerCase() === "female" && (
                  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                    <div className="flex items-center space-x-2 mb-4">
                      <FaWallet className="text-xl text-[var(--yellow)]" />
                      <h4 className="text-lg font-semibold">Coins Withdraw History</h4>
                    </div>

                    {withdrawalStats.loading ? (
                      <div className="flex justify-center py-4">
                        <div className="w-6 h-6 border-2 border-[var(--yellow)] border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-2 md:grid-cols-6 gap-4 text-center">
                        {[
                          ["Available Coins", withdrawalStats.availableCoins],
                          ["Available Amount", formatCurrency(availableAmountRupees)],
                          ["Total Earned Coins", withdrawalStats.earnedCoins + conversionSummary.totalCoinsConverted],
                          ["Earned Gifts Coins", withdrawalStats.earnedGiftsCoins],
                          ["Total Drawn Coins", conversionSummary.totalCoinsConverted],
                          ["Total Drawn Amount", `₹${formatNumber(conversionSummary.withdrawnAmount)}`],
                        ].map(([label, value]) => (
                          <div
                            key={label}
                            className="p-3 rounded-lg bg-[var(--black)] border border-[var(--yellow)]"
                          >
                            <p className="text-2xl font-bold">{typeof value === 'string' ? value : formatNumber(value)}</p>
                            <p className="text-sm opacity-80">{label}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

              </div>
            </>
          ) : activeTab === "Chats" ? (
            <div className="p-6 space-y-4">
              <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-2">
                    {selectedChat && (
                      <button
                        onClick={() => setSelectedChat(null)}
                        className="p-1 hover:bg-[var(--yellow)]/20 rounded-full transition text-[var(--yellow)] mr-2"
                        title="Back to list"
                      >
                        <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                      </button>
                    )}
                    <FaCommentDots className="text-xl text-[var(--yellow)]" />
                    <h4 className="text-lg font-semibold">
                      {selectedChat ? `Chat with ${selectedChat.otherUser.name}` : "Conversations"}
                    </h4>
                  </div>
                  {!selectedChat && chats.list.length > 0 && (
                    <span className="text-sm bg-[var(--yellow)] text-[var(--black)] px-2 py-0.5 rounded-full font-bold">
                      {chats.list.length}
                    </span>
                  )}
                </div>

                {selectedChat ? (
                  /* Message View */
                  <div className="space-y-4">
                    <div className="h-[400px] overflow-y-auto pr-2 space-y-3 custom-scrollbar">
                      {chatMessages.loading ? (
                        <div className="flex justify-center py-10">
                          <div className="w-8 h-8 border-2 border-[var(--yellow)] border-t-transparent rounded-full animate-spin"></div>
                        </div>
                      ) : chatMessages.list.length === 0 ? (
                        <div className="text-center py-10 opacity-60">
                          <p>No messages in this conversation.</p>
                        </div>
                      ) : (
                        chatMessages.list.map((msg) => {
                          const isMe = String(msg.senderId) === String(userId);
                          return (
                            <div
                              key={msg.id}
                              className={`flex ${!isMe ? "justify-end" : "justify-start"}`}
                            >
                              <div
                                className={`max-w-[80%] p-3 rounded-2xl ${
                                  !isMe
                                    ? "bg-[var(--yellow)] text-[var(--black)] rounded-tr-none"
                                    : "bg-[var(--yellow)]/10 text-[var(--yellow)] border border-[var(--yellow)]/30 rounded-tl-none"
                                }`}
                              >
                                <p className="text-sm">{msg.text}</p>
                                <p className={`text-[10px] mt-1 opacity-60 ${!isMe ? "text-right" : "text-left"}`}>
                                  {msg.timestamp instanceof Date ? msg.timestamp.toLocaleString() : "—"}
                                </p>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                ) : (
                  /* Conversation List */
                  chats.loading ? (
                    <div className="flex justify-center py-8">
                      <div className="w-8 h-8 border-2 border-[var(--yellow)] border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  ) : chats.list.length === 0 ? (
                    <div className="text-center py-8 opacity-60">
                      <p>No chat history found for this user.</p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {chats.list.map((chat) => (
                        <div
                          key={chat.id}
                          onClick={() => {
                            setSelectedChat(chat);
                            fetchChatMessages(chat.id);
                          }}
                          className="flex items-center gap-4 p-3 rounded-xl border border-[var(--yellow)]/30 hover:border-[var(--yellow)]/60 transition bg-[var(--black)] cursor-pointer"
                        >
                          <img
                            src={chat.otherUser.image || "https://via.placeholder.com/50"}
                            alt={chat.otherUser.name}
                            className="w-12 h-12 rounded-full object-cover border border-[var(--yellow)]/50"
                          />
                          <div className="flex-1 min-w-0">
                            <div className="flex justify-between items-start">
                              <h5 className="font-semibold text-[var(--yellow)] truncate">
                                {chat.otherUser.name}
                              </h5>
                              <span className="text-[10px] opacity-60 flex-shrink-0">
                                {chat.updatedAt?.toDate
                                  ? chat.updatedAt.toDate().toLocaleString()
                                  : chat.updatedAt
                                  ? new Date(chat.updatedAt).toLocaleString()
                                  : "—"}
                              </span>
                            </div>
                            <p className="text-sm opacity-80 truncate mt-0.5">
                              {chat.lastMessage?.text || "No messages yet"}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
            </div>
          ) : activeTab === "Call Transactions" ? (
            <>
              <div className="p-6 space-y-4">
                <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                  <h4 className="text-lg font-semibold mb-4">Recent Calls</h4>
                  {callTx.loading ? (
                    <div className="flex justify-center py-4">
                      <div className="w-6 h-6 border-2 border-[var(--yellow)] border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  ) : callTx.list.length === 0 ? (
                    <p className="opacity-80 text-sm">No call history</p>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="bg-[var(--yellow)] text-[var(--black)] text-xs uppercase font-semibold">
                            <th className="py-2 px-3 text-left">Date</th>
                            <th className="py-2 px-3 text-left">With</th>
                            <th className="py-2 px-3 text-left">Type</th>
                            <th className="py-2 px-3 text-left">Duration</th>
                            <th className="py-2 px-3 text-left">Status</th>
                            <th className="py-2 px-3 text-left">{model?.gender?.toLowerCase() === "female" ? "Earning" : "Spent"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {callTx.list.map((tx, idx) => {
                            const isCaller = tx?.callerId && String(tx.callerId._id) === String(userId);
                            const other = isCaller ? tx?.receiverId : tx?.callerId;
                            const withName = other?.fullName || other?.name || "—";
                            const dateStr = tx.callStartTime || tx.createdAt;
                            const minutes = tx.durationMinutes || 0;
                            const type = tx.callType || "—";
                            const status = tx.status || "—";
                            const isFemale = String(model?.gender || "").toLowerCase() === "female";
                            let coinVal = null;
                            if (isFemale) {
                              coinVal =
                                typeof tx.receiverEarnings === "number"
                                  ? tx.receiverEarnings
                                  : typeof tx.totalCoins === "number" && typeof tx.adminCommissionAmount === "number"
                                  ? tx.totalCoins - tx.adminCommissionAmount
                                  : null;
                            } else {
                              coinVal =
                                typeof tx.totalCoins === "number"
                                  ? tx.totalCoins
                                  : typeof tx.spentCoins === "number"
                                  ? tx.spentCoins
                                  : null;
                            }
                            return (
                              <tr key={idx} className="border-t border-[var(--yellow)]/40">
                                <td className="py-2 px-3">{dateStr ? new Date(dateStr).toLocaleString() : "—"}</td>
                                <td className="py-2 px-3">{withName}</td>
                                <td className="py-2 px-3">{String(type).toUpperCase()}</td>
                                <td className="py-2 px-3">{minutes} min</td>
                                <td className="py-2 px-3">{status}</td>
                                <td className="py-2 px-3">
                                  {typeof coinVal === "number" ? coinVal : "—"}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {callTx.totalPages > 1 && (
                    <div className="mt-4 flex justify-center items-center gap-3">
                      <button
                        disabled={callTx.page === 1}
                        onClick={() => fetchCallTransactions(callTx.page - 1)}
                        className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                      >
                        Prev
                      </button>
                      <span>
                        {callTx.page} / {callTx.totalPages}
                      </span>
                      <button
                        disabled={callTx.page === callTx.totalPages}
                        onClick={() => fetchCallTransactions(callTx.page + 1)}
                        className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : activeTab === "Earning/Deductions" ? (
            <>
              <div className="p-6 space-y-4">
                <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                  <h4 className="text-lg font-semibold mb-4">Earning / Deductions</h4>
                  {coinTx.loading ? (
                    <div className="flex justify-center py-4">
                      <div className="w-6 h-6 border-2 border-[var(--yellow)] border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  ) : coinTx.list.length === 0 ? (
                    <p className="opacity-80 text-sm">No transactions</p>
                  ) : (
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="bg-[var(--yellow)] text-[var(--black)] text-xs uppercase font-semibold">
                            <th className="py-2 px-3 text-left">Date</th>
                            <th className="py-2 px-3 text-left">Source</th>
                            <th className="py-2 px-3 text-left">Type</th>
                            <th className="py-2 px-3 text-left">Coins</th>
                            <th className="py-2 px-3 text-left">Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {coinTx.list.map((tx, idx) => {
                            const coinsVal =
                              typeof tx.coins === "number" ? tx.coins :
                              typeof tx.earnedCoins === "number" ? tx.earnedCoins :
                              typeof tx.spentCoins === "number" ? tx.spentCoins :
                              typeof tx.deductionCoins === "number" ? tx.deductionCoins :
                              typeof tx.amountCoins === "number" ? tx.amountCoins : null;
                            const typeStrRaw = typeof tx.type === "string" ? tx.type.toUpperCase() : "";
                            const isCredit =
                              typeStrRaw.includes("CREDIT") ||
                              (typeof coinsVal === "number" && coinsVal > 0) ||
                              (typeof tx.earnedCoins === "number" && tx.earnedCoins > 0);
                            const isDeduct =
                              typeStrRaw.includes("DEBIT") ||
                              typeStrRaw.includes("DEDUCT") ||
                              (typeof coinsVal === "number" && coinsVal < 0) ||
                              (typeof tx.spentCoins === "number" && tx.spentCoins > 0) ||
                              (typeof tx.deductionCoins === "number" && tx.deductionCoins > 0);
                            const typeLabel = isCredit ? "Credit" : (isDeduct ? "Deduct" : "—");
                            return (
                              <tr key={idx} className="border-t border-[var(--yellow)]/40">
                                <td className="py-2 px-3">{tx.createdAt ? new Date(tx.createdAt).toLocaleString() : "—"}</td>
                                <td className="py-2 px-3">{tx.source || "—"}</td>
                                <td className="py-2 px-3">{typeLabel}</td>
                                <td className="py-2 px-3">{typeof coinsVal === "number" ? coinsVal : "—"}</td>
                                <td className="py-2 px-3">{tx.description || "—"}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {coinTx.totalPages > 1 && (
                    <div className="mt-4 flex justify-center items-center gap-3">
                      <button
                        disabled={coinTx.page === 1}
                        onClick={() => fetchCoinTransactions(coinTx.page - 1)}
                        className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                      >
                        Prev
                      </button>
                      <span>
                        {coinTx.page} / {coinTx.totalPages}
                      </span>
                      <button
                        disabled={coinTx.page === coinTx.totalPages}
                        onClick={() => fetchCoinTransactions(coinTx.page + 1)}
                        className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : activeTab === "Purchases/Withdraws" ? (
            <>
              <div className="p-6 space-y-4">
                {model?.gender?.toLowerCase() === "female" ? (
                  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                    <h4 className="text-lg font-semibold mb-4">Withdraws</h4>
                    {(() => {
                      const list = Array.isArray(withdrawTx.list) ? withdrawTx.list : [];
                      const latest =
                        list.length > 0
                          ? [...list].sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))[0]
                          : null;
const currentRemaingAmount = conversionSummary.availableBalance || 0;
const TotalwithdrawnAmount = conversionSummary.withdrawnAmount || 0;
                      return (
                        <div className="grid grid-cols-2 md:grid-cols-2 gap-4 text-center mb-4">
                          <div className="p-3 rounded-lg bg-[var(--black)] border border-[var(--yellow)]">
                            <p className="text-2xl font-bold">{formatCurrency(currentRemaingAmount > 0 ? (withdrawalStats.availableCoins || 0) / coinsToRupees : 0)}</p>
                            <p className="text-sm opacity-80">Remaining Amount</p>
                          </div>
                          <div className="p-3 rounded-lg bg-[var(--black)] border border-[var(--yellow)]">
                            <p className="text-2xl font-bold">{formatCurrency(TotalwithdrawnAmount )}</p>
                            <p className="text-sm opacity-80">Total Withdrawn Amount</p>
                          </div>
                        </div>
                      );
                    })()}
                    {withdrawTx.loading ? (
                      <div className="flex justify-center py-4">
                        <div className="w-6 h-6 border-2 border-[var(--yellow)] border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    ) : withdrawTx.list.length === 0 ? (
                      <p className="opacity-80 text-sm">No withdrawals</p>
                    ) : (
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                          <thead>
                            <tr className="bg-[var(--yellow)] text-[var(--black)] text-xs uppercase font-semibold">
                              <th className="py-2 px-3 text-left">Date</th>
                              <th className="py-2 px-3 text-left">Current Amount</th>
                              <th className="py-2 px-3 text-left">Amount (Withdraw)</th>
                              <th className="py-2 px-3 text-left">Remaining Amount</th>
                              <th className="py-2 px-3 text-left">UPI Details</th>
                              <th className="py-2 px-3 text-left">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[...withdrawTx.list].map((w, idx) => {
                              const currentAmount =
                                coinsToRupees > 0 ? (withdrawalStats.availableCoins || 0) / coinsToRupees : 0;
                              const withdrawAmt = w?.amount || 0;
                              const remainingAmt = Math.max(currentAmount - withdrawAmt, 0);
                              const pmd = w?.paymentMethodDetails || {};
                              const upiName = pmd?.displayName || "N/A";
                              const upiId = pmd?.upiId || "N/A";
                              return (
                                <tr key={idx} className="border-t border-[var(--yellow)]/40">
                                  <td className="py-2 px-3">{w.createdAt ? new Date(w.createdAt).toLocaleString() : "—"}</td>
                                  <td className="py-2 px-3">{formatCurrency(currentAmount)}</td>
                                  <td className="py-2 px-3">{formatCurrency(withdrawAmt)}</td>
                                  <td className="py-2 px-3">
                                    {formatCurrency(remainingAmt)}
                                  </td>
                                  <td className="py-2 px-3">
                                    <div className="space-y-1">
                                      <div>
                                        <span className="font-medium">Name:</span> {upiName}
                                      </div>
                                      <div>
                                        <span className="font-medium">ID:</span> {upiId}
                                      </div>
                                    </div>
                                  </td>
                                  <td className="py-2 px-3">{w.status || "—"}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {withdrawTx.totalPages > 1 && (
                      <div className="mt-4 flex justify-center items-center gap-3">
                        <button
                          disabled={withdrawTx.page === 1}
                          onClick={() => fetchUserWithdrawals(withdrawTx.page - 1)}
                          className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                        >
                          Prev
                        </button>
                        <span>
                          {withdrawTx.page} / {withdrawTx.totalPages}
                        </span>
                        <button
                          disabled={withdrawTx.page === withdrawTx.totalPages}
                          onClick={() => fetchUserWithdrawals(withdrawTx.page + 1)}
                          className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="border border-[var(--yellow)] rounded-xl p-4 bg-[var(--black)]">
                    <h4 className="text-lg font-semibold mb-4">Purchages</h4>
                    {purchaseTx.loading ? (
                      <div className="flex justify-center py-4">
                        <div className="w-6 h-6 border-2 border-[var(--yellow)] border-t-transparent rounded-full animate-spin"></div>
                      </div>
                    ) : purchaseTx.list.length === 0 ? (
                      <p className="opacity-80 text-sm">No purchases</p>
                    ) : (
                      <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                          <thead>
                            <tr className="bg-[var(--yellow)] text-[var(--black)] text-xs uppercase font-semibold">
                              <th className="py-2 px-3 text-left">Date</th>
                              <th className="py-2 px-3 text-left">Package</th>
                              <th className="py-2 px-3 text-left">Coins</th>
                              <th className="py-2 px-3 text-left">Amount</th>
                              <th className="py-2 px-3 text-left">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {purchaseTx.list.map((t, idx) => (
                              <tr key={idx} className="border-t border-[var(--yellow)]/40">
                                <td className="py-2 px-3">{t.createdAt ? new Date(t.createdAt).toLocaleString() : "—"}</td>
                                <td className="py-2 px-3">{t.packageName || "—"}</td>
                                <td className="py-2 px-3">{typeof t.coins === "number" ? t.coins : "—"}</td>
                                <td className="py-2 px-3">₹{(t.amount || 0).toLocaleString("en-IN")}</td>
                                <td className="py-2 px-3">{t.status || "—"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {purchaseTx.totalPages > 1 && (
                      <div className="mt-4 flex justify-center items-center gap-3">
                        <button
                          disabled={purchaseTx.page === 1}
                          onClick={() => fetchPurchaseHistory(purchaseTx.page - 1)}
                          className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                        >
                          Prev
                        </button>
                        <span>
                          {purchaseTx.page} / {purchaseTx.totalPages}
                        </span>
                        <button
                          disabled={purchaseTx.page === purchaseTx.totalPages}
                          onClick={() => fetchPurchaseHistory(purchaseTx.page + 1)}
                          className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] rounded-lg disabled:opacity-40"
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
